import { replacePrismicObject } from '@swegaming-ab/nuxtjs-helpers';

const DOCUMENT_TYPES = {
    lender: {
        model: 'Loan',
        storeKey: 'lenders',
        shortcodes: 'lenderShortcodes'
    },
    lender_corporate: {
        model: 'CorporateLoan',
        storeKey: 'corporateLenders',
        shortcodes: 'lenderShortcodes'
    },
    lender_mortgage: {
        model: 'Mortgage',
        storeKey: 'mortgages',
        shortcodes: 'lenderShortcodes'
    },
    credit_card: {
        model: 'CreditCard',
        storeKey: 'cards',
        shortcodes: 'cardShortcodes'
    }
};

export default ({ app, store }, inject) => {
    const lenderShortcodes = (document, model) => {
        const monthShort = app.$translate('month_short', 'mån');
        const yearShort = app.$translate('year_short', 'år');
        return {
            title: document.data.title,
            lender: document.data.title,
            connectedBanks: model.connectedBanks,
            amount: model.amountString,
            maxAmount: model.maxAmountString,
            minAmount: model.minAmountString,
            duration: model.getDurationString(monthShort, yearShort),
            minDuration: model.getMinDurationString(monthShort, yearShort),
            maxDuration: model.getMaxDurationString(monthShort, yearShort),
            interest: model.interestString,
            minInterest: model.minInterestPossibleString,
            maxInterest: model.maxInterestPossibleString,
            effectiveInterest: model.effectiveInterestString,
            minEffectiveInterest: model.minEffectiveInterestPossibleString,
            maxEffectiveInterest: model.maxEffectiveInterestPossibleString,
            setupFee: model.setupFeeString,
            administrationFee: model.administrationFeeString,
            minAge: model.minAge,
            creditCheck: app.$getCreditCheckString(model.creditCheck),
            minRevenue: model.companyRequirementsString?.minRevenue,
            maxLTV: model.maxLTVRatioString,
            downPayment: model.downPaymentString
        };
    };

    const cardShortcodes = (document, model) => ({
        title: document.data.title,
        card: document.data.title,
        maxCredit: model.getMaxCreditString(),
        interest: model.interestString,
        effectiveInterest: model.effectiveInterestString,
        yearlyCost: model.yearlyCostString,
        interestFreeDays: model.getInterestFreeDaysString()
    });

    const shortcodeBuilders = {
        lenderShortcodes,
        cardShortcodes
    };

    const getDocumentContext = (document) => {
        const type = DOCUMENT_TYPES[document.type];
        if (!type) {
            return null;
        }

        const prismicDocument = document.data
            ? document
            : store.state[type.storeKey][document.id];

        if (!prismicDocument) {
            return null;
        }

        return {
            document: prismicDocument,
            model: new app.$models[type.model](prismicDocument),
            type
        };
    };

    inject('replaceShortcodes', (text, document, selectedShortcodes) => {
        if (!app.$validateText(text) || !document?.type || !DOCUMENT_TYPES[document.type]) {
            return text;
        }

        const documentContext = getDocumentContext(document);
        if (!documentContext) {
            return text;
        }

        const shortcodes = shortcodeBuilders[documentContext.type.shortcodes](documentContext.document, documentContext.model);

        const activeShortcodes = selectedShortcodes
            ? Object.entries(shortcodes).filter(([key]) => selectedShortcodes.includes(key))
            : Object.entries(shortcodes);

        if (Array.isArray(text)) {
            const clonedText = JSON.parse(JSON.stringify(text));
            for (const [shortcode, value] of activeShortcodes) {
                replacePrismicObject(clonedText, `{${shortcode}}`, String(value ?? ''));
            }
            return clonedText;
        }

        let result = text;
        for (const [shortcode, value] of activeShortcodes) {
            result = result.replaceAll(`{${shortcode}}`, String(value ?? ''));
        }
        return result;
    });
};
